export enum NotificationActionTypes {
    LOAD_NOTIFICATIONS = 'LOAD_NOTIFICATIONS',
    UPDATE_NOTIFICATION = 'UPDATE_NOTIFICATIONS',
    PUSH_NOTIFICATION = 'PUSH_NOTIFICATION',
    DISMISS_NOTIFICATION = 'DISMISS_NOTIFICATION',
    ACCEPT_REJECT_CONTRACT_NOTIFICATION = 'ACCEPT_REJECT_CONTRACT_NOTIFICATION',
    SHOW_NOTIFICATION_POPUP = 'SHOW_NOTIFICATION_POPUP',
}
